<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Void Pembayaran</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TRANSAKSI</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label"><strong>No. Kwitansi</strong></b-col>
                    <b-col v-if="detailVoidPby.noKwitansi != null"><strong>{{ detailVoidPby.noKwitansi }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                    <b-col v-if="detailVoidPby.noFaktur != null"><strong>{{ detailVoidPby.noFaktur }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diajukan pada</b-col>
                    <b-col v-if="detailVoidPby.diajukanPada != null">{{ $helper.changeDateFormat(detailVoidPby.diajukanPada )}} {{ $helper.changeDateFormatGetHour(detailVoidPby.diajukanPada )}}</b-col>
                    <b-col v-else>---SISTEM---</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diajukan oleh</b-col>
                    <b-col v-if="detailVoidPby.diajukanOleh != null">{{ detailVoidPby.diajukanOleh }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang</b-col>
                    <b-col v-if="detailVoidPby.cabang != null">{{ detailVoidPby.cabang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col v-if="detailVoidPby.status != null">{{ detailVoidPby.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4 mt-4">
                <h6 class="form-title mb-2">ANGGOTA</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">No. Anggota</b-col>
                    <b-col>{{ detailVoidPby.nomorAnggota }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Nama</b-col>
                    <b-col>{{ detailVoidPby.namaAnggota }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">KETERANGAN</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Ajuan</b-col>
                    <b-col v-if="detailVoidPby.keteranganAjuan != null">{{ detailVoidPby.keteranganAjuan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>

            <div v-if="showVoidPembayaran" class="detail-data-wrapper mb-4">
                <h6 class="form-title">VOID PEMBAYARAN</h6>
                <b-row>
                    <b-col lg="4" md="6">
                        <b-form-group label="Keterangan">
                            <b-form-textarea v-model="keterangan" name="keterangan"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="cetak-sbg-btn">
                    <b-row class="ml-0 mt-2">
                        <b-button class="mr-2" variant="pgiBtn" name="cetakBtn" @click="approveVoidPembayaran">
                            Setujui
                        </b-button>
                        <b-button variant="danger" name="cetakBtn" @click="rejectVoidPembayaran">
                            Tolak
                        </b-button>
                    </b-row>
                </div>
            </div>

            <div v-else class="detail-data-wrapper mb-4">
                <h6 class="form-title">VOID PEMBAYARAN</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status Void Pembayaran</b-col>
                    <b-col>{{ detailVoidPby.status }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diproses pada</b-col>
                    <b-col v-if="detailVoidPby.processedAt != null">{{ $helper.changeDateFormat(detailVoidPby.processedAt )}} {{ $helper.changeDateFormatGetHour(detailVoidPby.processedAt )}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diproses oleh</b-col>
                    <b-col v-if="detailVoidPby.processedBy != null">{{ detailVoidPby.processedBy }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Approval</b-col>
                    <b-col v-if="detailVoidPby.keteranganApproval != null">{{ detailVoidPby.keteranganApproval }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
        </b-card>
        <ModalConfirm id="modal-approve-void" title="Confirm Approve Void Pembayaran" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menyetujui void pembayaran ini?" @submit="onApproveVoid" />
        <ModalConfirm id="modal-reject-void" title="Confirm Reject Void Pembayaran" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menolak void pembayaran ini?" @submit="onRejectVoid" />
    </div>
</template>

<script>

export default {
    name: 'detail-void-pembayaran',
    data(){
        return{
            id: null,
            initStatus: 0,
            detailVoidPby: [],
            isSubmitting: false,
            keterangan: "",
            showVoidPembayaran: false
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleVoidPby = this.$axios.get(`approval-void-pembayaran/${this.id}`).then(response => {
                this.detailVoidPby = response.data
                if (this.detailVoidPby.status == "PENDING") this.showVoidPembayaran = true

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleVoidPby]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Submit Request Cetak Kwitansi -----------------

        onApproveVoid(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("id", this.id)
            if (this.keterangan != "") payload.append("keterangan", this.keterangan)
            payload.append("approve", true)

            this.$axios.post("approval-void-pembayaran/process", payload).then(() => {
                this.$helper.setFlash(`Void pembayaran berhasil disetujui!`)
                
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Submit Request Void -----------------
        
        onRejectVoid(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("id", this.id)
            payload.append("keterangan", this.keterangan)
            payload.append("approve", false)

            this.$axios.post("approval-void-pembayaran/process", payload).then(() => {
                this.$helper.setFlash(`Void pembayaran berhasil ditolak!`)
                
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        approveVoidPembayaran(){
            if (this.keterangan == "") {
                this.$helper.toastErr(this, "Mohon masukkan keterangan di dalam kotak Keterangan!")
            } else {
                this.$bvModal.show("modal-approve-void")
            }
        },

        rejectVoidPembayaran(){
            if (this.keterangan == "") {
                this.$helper.toastErr(this, "Mohon masukkan keterangan di dalam kotak Keterangan!")
            } else {
                this.$bvModal.show("modal-reject-void")
            }
        },
        
    },

    created(){
        this.init()
    }
}
</script>
